module.exports = __webpack_public_path__ + "img/capability-slider-img-1.4e65a1ae.png";